import { TableCell } from '@mui/material';
import { type Cell, flexRender } from '@tanstack/react-table';
import cx from 'classnames';
import { useAtom } from 'jotai';

import { selectedCellAtom } from 'atoms/misc';
import { BACKGROUND_GREY } from 'theme/colors';

import {
  editableCellStyles,
  expandedCellStyles,
  pinnedLeftStyles,
  pinnedRightStyles,
  responsiveCellStyles,
  selectedCellStyles,
} from './styles';

interface EnhancedCellProps {
  cell: Cell<any, any>;
  index: number;
  isRowEditable: boolean;
  isRowExpandable: boolean;
  isRowHovered: boolean;
  resizingEnabled: boolean;
  toggleHoverRow: (state: boolean) => void;
}

const EnhancedCell = ({
  cell,
  index,
  isRowEditable,
  isRowExpandable,
  isRowHovered,
  resizingEnabled,
  toggleHoverRow,
}: EnhancedCellProps) => {
  const selectedCell = useAtom(selectedCellAtom)[0];

  const isSelected =
    selectedCell?.row?.id === cell.row.id && selectedCell?.column?.columnDef.header === cell.column.columnDef.header;

  const cellClasses = cx(...(cell.column.columnDef.meta?.cellClasses ?? []));
  const isEditableCell = cell.column.columnDef.meta?.isEditable;

  return (
    <TableCell
      className={cx(
        responsiveCellStyles(),
        cell.column.getIsPinned() === 'left' ? pinnedLeftStyles().className : '',
        cell.column.getIsPinned() === 'right' ? pinnedRightStyles().className : '',
        isRowExpandable ? expandedCellStyles().className : '',
        isEditableCell && !cell.row.getCanExpand() && !isSelected ? editableCellStyles().className : '',
        isSelected ? selectedCellStyles().className : '',
        !isRowExpandable ? cellClasses : [],
      )}
      style={{
        width: resizingEnabled && cell.column.getSize(),
        background: isRowHovered && !isSelected ? BACKGROUND_GREY : undefined,
        paddingLeft: isEditableCell ? 12 : undefined,
      }}
      {...(index === 0
        ? { as: 'th' }
        : { 'data-th': cell.column.columnDef.meta?.headerLabel ?? cell.column.columnDef.header })}
      onMouseLeave={() => isRowEditable && toggleHoverRow(false)}
      onMouseOver={() => isRowEditable && toggleHoverRow(true)}
    >
      {flexRender(cell.column.columnDef.cell, cell.getContext())}
    </TableCell>
  );
};

export default EnhancedCell;
